import type { FilterFieldConfig } from 'components/common/MasterFilter';

const salesBarConfig: FilterFieldConfig[] = [
  {
    key: 'searchTerm',
    kind: 'text',
    label: 'Buscar',
    placement: 'bar',
    placeholder: 'Nombre, RUT o Nro oportunidad',
  },
  // Options are fed at runtime from useAssignableUsers — a sale's executive is whoever its client
  // is assigned to.
  { key: 'assignedUser', kind: 'multiSelect', label: 'Ejecutivo', placement: 'bar' },
  // Deliberately without a defaultValue: sales uploaded before the CRM upload date became a column
  // have no date, and a preset range would hide all of them.
  { key: 'uploadedAt', kind: 'dateRange', label: 'Fecha subida CRM', placement: 'bar' },
];

export default salesBarConfig;
